// extracted by mini-css-extract-plugin
export default {"container":"TodoItem_container__m4X0Q","remove":"TodoItem_remove__u1Ft+","name":"TodoItem_name__1uk7C","remove_name":"TodoItem_remove_name__2O42p"};